import { formatNumberToContext } from '../utils/format-number-to-context.js'
import { valueFormatter } from '../utils/value-formatter.js'

export function makeConvertedAmountsColumns (context) {
  const shownCurrencyCode = context.menuOptions.optionCurrency.selectedOption().value

  const columnDefs = []

  columnDefs.push({
    headerName: `${shownCurrencyCode === 'XXX' ? 'Entity' : shownCurrencyCode} Amount`,
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null
      if (cellParams.data.type === 'entityPair') return null

      const signMultiplier = context.menuOptions.optionMultiplier.selectedOption().value === 'debitPositive' ? 1 : -1

      return cellParams.data.transaction?._converted_amount * signMultiplier
    },
    valueFormatter,
    cellRenderer: function (cellParams) {
      if (cellParams.data.type === 'entityPair') {
        const isBalancing = cellParams.data.rollupValue?.isBalancing
        if (isBalancing) {
          return `<span class="tag is-success">✓</span> ${formatNumberToContext(cellParams.data.rollupValue?.sideTotals?.[cellParams.data._entitiesPair[0]][1], cellParams.context)}`
        } else {
          return '<span class="tag is-warning">Debits not matching Credits</span>'
        }
      }

      return cellParams.valueFormatted
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: `${shownCurrencyCode === 'XXX' ? 'Entity' : shownCurrencyCode} Debits`,
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null
      if (cellParams.data.type === 'entityPair') return null

      const isDebit = cellParams.data.transaction?._converted_amount > 0
      if (!isDebit) return null

      let signMultiplier = context.menuOptions.optionMultiplier.selectedOption().value === 'debitPositive' ? 1 : -1
      // Always show positive numbers
      signMultiplier = signMultiplier * (context.menuOptions.optionMultiplier.selectedOption().value === 'debitPositive' ? 1 : -1)

      return cellParams.data.transaction?._converted_amount * signMultiplier
    },
    valueFormatter,
    cellRenderer: function (cellParams) {
      if (cellParams.data.type === 'entityPair') {
        const entitiesPair = cellParams.data._entitiesPair
        const valueSide = 1 // 1 = debits, -1 = credits
        const amountEntity1 = cellParams.data.rollupValue?.sideTotals?.[entitiesPair[0]]?.[valueSide]
        const amountEntity2 = cellParams.data.rollupValue?.sideTotals?.[entitiesPair[1]]?.[valueSide]
        if (amountEntity1 === amountEntity2) {
          return `<span class="tag is-success">✓</span> ${formatNumberToContext(amountEntity1, cellParams.context)}`
        } else {
          return `<span class="tag is-warning">!!</span> ${amountEntity1 ? formatNumberToContext(amountEntity1, cellParams.context) : '0'} vs. ${amountEntity2 ? formatNumberToContext(amountEntity2, cellParams.context) : '0'}`
        }
      }

      return cellParams.valueFormatted
    },
    type: 'numericColumn'
  })

  columnDefs.push({
    headerName: `${shownCurrencyCode === 'XXX' ? 'Entity' : shownCurrencyCode} Credits`,
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null
      if (cellParams.data.type === 'entityPair') return null

      const isDebit = cellParams.data.transaction?._converted_amount > 0
      if (isDebit) return null

      let signMultiplier = context.menuOptions.optionMultiplier.selectedOption().value === 'debitPositive' ? 1 : -1
      // Always show positive numbers
      signMultiplier = signMultiplier * (context.menuOptions.optionMultiplier.selectedOption().value === 'debitPositive' ? -1 : 1)

      return cellParams.data.transaction?._converted_amount * signMultiplier
    },
    valueFormatter,
    cellRenderer: function (cellParams) {
      if (cellParams.data.type === 'entityPair') {
        const entitiesPair = cellParams.data._entitiesPair
        const valueSide = -1 // 1 = debits, -1 = credits
        const amountEntity1 = cellParams.data.rollupValue?.sideTotals?.[entitiesPair[0]]?.[valueSide] || 0
        const amountEntity2 = cellParams.data.rollupValue?.sideTotals?.[entitiesPair[1]]?.[valueSide] || 0
        if (amountEntity1 === amountEntity2) {
          return `<span class="tag is-success">✓</span> ${formatNumberToContext(amountEntity1, cellParams.context)}`
        } else {
          return `<span class="tag is-warning">!!</span> ${amountEntity1 ? formatNumberToContext(amountEntity1, cellParams.context) : '0'} vs. ${amountEntity2 ? formatNumberToContext(amountEntity2, cellParams.context) : '0'}`
        }
      }

      return cellParams.valueFormatted
    },
    type: 'numericColumn'
  })

  return columnDefs
}
